import { StoreActionType as Type } from "../../types";

type CampaignFilterState = {
  data: [];
};

const initialState: CampaignFilterState = {
  data: [],
};

export const matrixCampaignFilterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.SET_CAMPAIGN_MATRIX_CAMPAIGN_FILTER:
      return { ...state, data: action.payload } as CampaignFilterState;
    default:
      return state;
  }
};
